export default {
    'name': 'plus',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12.4373 2.25C12.6267 2.38614 12.75 2.60835 12.75 2.85938V11.25H21.1406C21.3916 11.25 21.6139 11.3733 21.75 11.5627V12.4373C21.6139 12.6267 21.3916 12.75 21.1406 12.75H12.75V21.1406C12.75 21.3916 12.6267 21.6139 12.4373 21.75H11.5627C11.3733 21.6139 11.25 21.3916 11.25 21.1406V12.75H2.85938C2.60835 12.75 2.38614 12.6267 2.25 12.4373V11.5627C2.38614 11.3733 2.60835 11.25 2.85938 11.25H11.25V2.85938C11.25 2.60835 11.3733 2.38614 11.5627 2.25H12.4373Z\' fill=\'#026958\'/>'
}
